// Preview.js (Updated)
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';

export default function Preview() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const previewData = state?.previewData || [];
  const selected = state?.selected || 0;
  const fields = state?.fields || [];
  const canvasSize = state?.canvasSize || { width: 700, height: 842 };
  const sampleRecord = previewData[selected] || {};

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-stone-50 to-amber-50">
      <Header />
      <div className="max-w-5xl mx-auto px-4 py-10">
        <h1 className="text-2xl font-bold text-slate-800 mb-4">PDF Preview</h1>
        <div
          className="relative border border-dashed border-amber-400 rounded-xl bg-white shadow-md mx-auto"
          style={{ width: canvasSize.width, height: canvasSize.height }}
        >
          {fields.map((field, idx) => (
            <div
              key={idx}
              className="absolute px-3 py-1 rounded shadow-sm"
              style={{
                top: field.y,
                left: field.x,
                fontSize: field.fontSize,
                textAlign: field.align,
                color: field.color,
                background: field.bgColor,
                fontFamily: field.fontFamily,
                minWidth: 80,
              }}
            >
              {sampleRecord[field.key] || field.value}
            </div>
          ))}
        </div>
        <div className="mt-8 flex justify-center">
          <button
            className="bg-gradient-to-r from-slate-800 to-amber-600 text-white px-8 py-3 rounded-full hover:from-slate-900 hover:to-amber-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl font-medium"
            onClick={() => navigate(-1)}
          >
            Back to Designer
          </button>
        </div>
      </div>
    </div>
  );
}